// extracted by mini-css-extract-plugin
export default {"button":"raa7Q","text":"nYaCV"};